import { UserProgramCardData } from './UserProgramCardTypes'

export const getUserProgramStatus = (userProgramData: Partial<UserProgramCardData>) => {
  // @todo: actually look for incomplete steps
  if (userProgramData.currentStepType) {
    return 'actionNeeded'
  }
  if (userProgramData.enrolling) {
    return 'enrolling'
  }
  if (userProgramData.enrolled) {
    return 'enrolled'
  }
  if (userProgramData.eligibleForEnrollment) {
    return 'eligible'
  }

  return 'ineligible'
}
